import { render, staticRenderFns } from "./needDocument.vue?vue&type=template&id=0103aecb&scoped=true&"
import script from "./needDocument.vue?vue&type=script&lang=ts&"
export * from "./needDocument.vue?vue&type=script&lang=ts&"
import style0 from "./needDocument.vue?vue&type=style&index=0&id=0103aecb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0103aecb",
  null
  
)

export default component.exports